module.exports = __webpack_public_path__ + "media/images/lane/black-icon_instagram-35f7236b4baf0824c7e6a36c3e7371d3.svg";